import { TbRouter } from "react-icons/tb";

function RouterIcon(props: any) {

    const xPosition = props.xPosition;
    const yPosition = props.yPosition;

    return (
        <div style={{ position: 'absolute', left: xPosition, top: yPosition }}>
            <div id='icons' className='icon shadow-4'>
                <TbRouter style={{ color: 'white' }} size="20px" />
            </div>
        </div>
    )
}

export default RouterIcon